import request from "@/utils/request";

export function apiWorkbench(params) {
  return request.get("/workbench/index", params);
}
